import { Controller } from '@hotwired/stimulus';

import { nextFrame } from '../../utils/transition';

// Variables shared between multiple instances of the controller
let lastScrollPosition = 0;
let ticking = false;
let show = true;
let previousState = null;

export default class extends Controller {
    static values = {
        adBannerId: String,
    };

    connect() {
        // Ensure header is still static/sticky when AJAX request updates DOM
        if (previousState) {
            this.element.style.transform = previousState.transform;

            previousState = null;
        }

        window.addEventListener('scroll', this.#onScroll, { passive: true });
    }

    disconnect() {
        previousState = {
            transform: this.element.style.transform,
        };

        window.removeEventListener('scroll', this.#onScroll);
    }

    #onScroll = () => {
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        const headerHeight = this.element.getBoundingClientRect().height;

        if (currentScrollPosition < 0) {
            return;
        }

        if (Math.abs(currentScrollPosition - lastScrollPosition) < headerHeight) {
            return;
        }

        show = currentScrollPosition <= lastScrollPosition;
        lastScrollPosition = currentScrollPosition;

        if (!ticking) {
            nextFrame().then(() => {
                this.#toggleAdBanner();
                this.#toggleStickyHeader();
                ticking = false;
            });

            ticking = true;
        }
    };

    async #toggleStickyHeader() {
        if (!show) {
            const headerHeight = this.element.getBoundingClientRect().height;
            this.element.style.transform = `translateY(-${headerHeight}px)`;

            await nextFrame();
        } else {
            this.element.style.transform = 'translateY(0)';
        }
    }

    #toggleAdBanner() {
        if (!this.hasAdBannerIdValue) {
            return;
        }

        const adsBanner = document.getElementById(this.adBannerIdValue);
        if (!adsBanner) {
            return;
        }

        const classesToAdd = ['sm:tw-static', 'tw-top-0'];

        if (!show) {
            adsBanner.classList.add(...classesToAdd);
        } else {
            adsBanner.classList.remove(...classesToAdd);
        }
    }
}
